<template>
  <div>
  <!-- <div v-if="!showFlag" class="productBtn" @click="showCompareBox">
    <span>PK</span>
    <span>对比</span>
    <i v-if="productList.length > 0">{{productList.length}}</i>
  </div> -->
  <div v-if="showFlag" class="productCompare" >
    <div class="title">
      <span>商品对比</span>
      <span @click="hideCompareBox">隐藏对比框</span>
    </div>
    <div class="content">
      <ul>
        <li v-for="(item, index) in productList" :key="index">
          <a :href="'/#/product/detail?id='+item.productId" target="_blank">
            <img class="productImg" v-lazy='ExchangeImageUrl(item.imageUrl)'>
          </a>
          <div class="productInfo">
            <a class="disc" :href="'/#/product/detail?id='+item.productId" target="_blank" :title="item.productName">{{item.productName}}</a>
            <span class="price">￥{{item.productPrice}}</span>
            <span class="delt" @click="moveFromCompareBox(item.id)">移除</span>
          </div>
        </li>
      </ul>
      <div class="operate">
        <button @click="gotoCompareDetail" :class="productList.length < 2 ? 'disable': 'btn'" :disabled="productList.length < 2 ? true : false">对比</button>
        <span @click="clearCompareBox">清空对比栏</span>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import eventHref from '../../helpers/eventhref.js'
export default {
  props: {
    showCompare: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      showFlag: false,
      // memberId: '',
      productList: []
    }
  },
  watch: {
    showCompare (newVal) {
      if (newVal) {
        this.showFlag = newVal
      }
    },
    showFlag (newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  mounted () {
    this.memberId = $.data.get('MemberId')
    if (this.memberId) {
      this.initPage()
    }
    eventHref.$on('getcompareBoxInfo', () => {
      this.initPage()
      eventHref.$off('getcompareBoxInfo')
    })
  },
  methods: {
    initPage () {
      const params = {
        memberId: $.data.get('MemberId')
      }
      this.get('/cartcompare/getListByMemberId.html', params, (e) => {
        if (e.success) {
          this.productList = e.data || []
          this.$store.state.compareGoodNum = this.productList.length
        } else {
          $.ui.alert('提示', e.message)
        }
      })
    },
    moveFromCompareBox (id) {
      const params = {
        id: id
      }
      this.post('/cartcompare/deleteById.html', params, (e) => {
        if (e.success) {
          $.ui.toast('移除成功', 'success')
          this.initPage()
        } else {
          $.ui.alert('提示', e.message)
        }
      })
    },
    clearCompareBox () {
      const params = {
        memberId: $.data.get('MemberId')
      }
      this.post('/cartcompare/deleteByMemberId.html', params, (e) => {
        if (e.success) {
          $.ui.toast('清空对比框成功', 'success')
          this.initPage()
        } else {
          $.ui.alert('提示', e.message)
        }
      })
    },
    gotoCompareDetail () {
      if (this.productList.length < 2) {
        $.ui.toast('对比需要2个以上的商品')
        return
      }
      this.href('/product/compare')
    },
    hideCompareBox () {
      this.showFlag = false
    },
    showCompareBox () {
      this.showFlag = true
    }
  }
}
</script>
<style lang="css" scoped>
  .productBtn {
    width: 56px;
    height: 56px;
    background: #003388;
    position: fixed;
    right: 9px;
    top: 182px;
    cursor: pointer;
  }
  .productBtn span {
    display: block;
    color: #fff;
    text-align: center;
  }
  .productBtn span:first-child {
    font-size: 22px;
    font-weight: bold;
    margin-top: 12px;
  }
  .productBtn span:nth-child(2) {
    font-size: 12px;
  }
  .productBtn i {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #C30013;
    font-style: normal;
    font-size: 12px;
    color: #fff;
    line-height: 15px;
    text-align: center;
    position: absolute;
    top: -8px;
    right: -8px;

  }
  .productCompare {
    width: 210px;
    height: 495px;
    border: 1px solid #c2cad8;
    background-color: #fff;
    position: fixed;
    right: 0;
    top: 210px;
    z-index: 9991;
    box-sizing: border-box;
    overflow: hidden;
  }
  .productCompare .title {
    line-height: 43px;
    background-color: #f7f7f7;
    border-bottom: 1px solid #c2cad8;
    padding: 0 12px;
    color: rgba(0, 0, 0, 0.65);
    overflow: hidden;
  }
  .title>span:first-child {
    font-size: 14px;
    float: left;
  }
  .title>span:last-child {
    font-size: 12px;
    float: right;
    cursor: pointer;
  }
  .productCompare .content {
    width: 210px;
    overflow: hidden;
    padding: 0px 8px;
  }
  .content ul {
    height: 364px;
    overflow: hidden;
  }
  .content ul li {
    width:194px;
    height: 74px;
    border-bottom: 1px dotted #f0f2f5;
    box-sizing: border-box;
    margin: 12px 0;
  }
  .content .productImg {
    float: left;
    width: 48px;
    height: 48px;
  }
  .content .productInfo {
    float: left;
    width: 138px;
    margin-left: 8px;
  }
  .productInfo .disc {
    display: inline-block;
    line-height: 18px;
    font-size: 12px;
    height: 36px;
    overflow: hidden;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
  }
  .productInfo .price {
    float: left;
    color: red;
    font-size: 14px;
    line-height: 24px;
  }
  .productInfo .delt {
    float: right;
    background-color:#003388;
    color: #fff;
    padding: 3px 12px;
    border-radius: 2px;
    cursor: pointer;
    font-size: 14px;
  }
  .content .operate {
    width: 194px;
    display: flex;
    flex-direction: column;
    justify-content: center;

  }
  .operate>button {
    margin-left: 45px;
    cursor: pointer;
    width: 104px;
    height: 36px;

  }
  .operate .btn {
    border: 1px solid #003388;
    background-color: #003388;
    color: #fff;
  }
  .operate>span {
    margin-top: 12px;
    text-align: center;
    cursor: pointer;
    position: relative;
    padding-left: 20px;
  }
  .operate>span::before {
    content: '';
    position: absolute;
    left: 60px;
    top: 2px;
    width: 16px;
    height: 16px;
    background: url('../../assets/PageCommon/img/delete.png');
  }
  .operate .disable {
    background-color: #ccc !important;
    border: 1px solid #ccc !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/commons/productCompare.vue